import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api';
import { DevicePreview } from '../types';

const DEVICE_PREVIEW_URL = '/templates/getPreviews';

export const useGetDevicePreviews = (
  params: Record<string, unknown>,
  options: RestQueryHookOptions = {},
) => {
  const { data, isLoading, error, refetch } = useRestQuery<Record<string, DevicePreview>>(
    DEVICE_PREVIEW_URL,
    params,
    {
      refetchOnWindowFocus: false,
      retry: false,
      ...options,
    },
  );

  return {
    previews: data && typeof data === 'object' ? Object.values(data) : [],
    isLoading,
    error,
    refetch,
  };
};
